module.exports = __webpack_public_path__ + "img/3.ce8375f4.png";